import React from 'react';
import { Leaf, Shield, Lock, Eye, Database, UserCheck } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <header className="app-header">
        <div className="header-content">
          <div className="logo">
            <Leaf size={32} />
            <span>BoAI</span>
          </div>
        </div>
      </header>

      <div className="privacy-content">
        <div className="container">
          <h1 className="privacy-title">
            <Shield size={48} />
            Privacy Policy & Data Security
          </h1>
          <p className="hindi-text">गोपनीयता नीति और डेटा सुरक्षा</p>

          <div className="privacy-section">
            <div className="section-icon">
              <Lock size={32} />
            </div>
            <h2>Data Security / डेटा सुरक्षा</h2>
            <ul>
              <li>✓ All data transmitted over HTTPS (encrypted)</li>
              <li>✓ Passwords protected with bcrypt hashing</li>
              <li>✓ JWT token-based authentication</li>
              <li>✓ Payment processing via secure Razorpay</li>
              <li>✓ Regular security updates and monitoring</li>
            </ul>
          </div>

          <div className="privacy-section">
            <div className="section-icon">
              <Database size={32} />
            </div>
            <h2>Data We Collect / हम जो डेटा एकत्र करते हैं</h2>
            <ul>
              <li><strong>Account Information:</strong> Email, mobile number, password (encrypted)</li>
              <li><strong>Crop Scans:</strong> Images, disease detection results, scan history</li>
              <li><strong>Payment Data:</strong> Transaction IDs only (no card details stored)</li>
              <li><strong>Usage Data:</strong> Scan counts, tier information</li>
            </ul>
          </div>

          <div className="privacy-section">
            <div className="section-icon">
              <Eye size={32} />
            </div>
            <h2>How We Use Your Data / हम आपके डेटा का उपयोग कैसे करते हैं</h2>
            <ul>
              <li>Provide crop disease detection services</li>
              <li>Maintain your scan history</li>
              <li>Process payments and subscriptions</li>
              <li>Send OTP for authentication</li>
              <li>Improve our AI models and services</li>
            </ul>
          </div>

          <div className="privacy-section">
            <div className="section-icon">
              <UserCheck size={32} />
            </div>
            <h2>Your Rights / आपके अधिकार</h2>
            <ul>
              <li><strong>Access:</strong> Request copy of your data</li>
              <li><strong>Delete:</strong> Request account and data deletion</li>
              <li><strong>Update:</strong> Modify your information anytime</li>
              <li><strong>Export:</strong> Download your scan history</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Data Retention / डेटा प्रतिधारण</h2>
            <ul>
              <li>Account data: Retained while account is active</li>
              <li>Scan history: Retained to provide service</li>
              <li>OTPs: Automatically deleted after 5 minutes</li>
              <li>Payment records: Retained for accounting (transaction IDs only)</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Third-Party Services / तृतीय-पक्ष सेवाएं</h2>
            <ul>
              <li><strong>OpenAI:</strong> For crop disease AI detection (images processed, not stored)</li>
              <li><strong>Razorpay:</strong> For secure payment processing (PCI DSS compliant)</li>
              <li><strong>SMS Provider:</strong> For OTP delivery (mobile numbers only)</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Data Storage / डेटा भंडारण</h2>
            <ul>
              <li>Data stored on secure servers</li>
              <li>Regular backups maintained</li>
              <li>Access restricted to authorized personnel only</li>
              <li>Compliant with Indian IT Act 2000</li>
            </ul>
          </div>

          <div className="privacy-section security-highlight">
            <h2>🔒 Security Commitment</h2>
            <p>
              We take your privacy seriously. Your data is encrypted, secure, and never sold to third parties.
              We use industry-standard security practices to protect your information.
            </p>
            <p className="hindi-text">
              हम आपकी गोपनीयता को गंभीरता से लेते हैं। आपका डेटा एन्क्रिप्टेड, सुरक्षित है और कभी भी तीसरे पक्ष को नहीं बेचा जाता है।
            </p>
          </div>

          <div className="privacy-footer">
            <p>Last Updated: {new Date().toLocaleDateString('en-IN')}</p>
            <p>For questions or concerns, contact us through the app.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
